export const testcolor = "119, 141, 199,0.6"


export const blackColor = '#000000'
export const whiteColor = '#ffffff'
export const primaryColor = '#F36C3C'
export const secondaryColor = '#243C80'
export const primaryLightColor = '#E8A68E'
export const secondaryLightColor = '#778DC7'